<template>
  <div class="container">
    <div class="icon">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45 11.9999C45 10.4086 44.3679 8.88245 43.2426 7.75723C42.1174 6.63201 40.5913 5.99987 39 5.99987H37.5V4.54205C37.5 3.73486 36.8794 3.04205 36.0722 3.00174C35.8694 2.99197 35.6667 3.02347 35.4764 3.09435C35.2861 3.16523 35.1122 3.274 34.9652 3.41407C34.8182 3.55414 34.7012 3.7226 34.6212 3.90924C34.5413 4.09588 34.5 4.29682 34.5 4.49987V5.99987H13.5V4.54205C13.5 3.73486 12.8794 3.04205 12.0722 3.00174C11.8694 2.99197 11.6667 3.02347 11.4764 3.09435C11.2861 3.16523 11.1122 3.274 10.9652 3.41407C10.8182 3.55414 10.7012 3.7226 10.6212 3.90924C10.5413 4.09588 10.5 4.29682 10.5 4.49987V5.99987H9C7.4087 5.99987 5.88258 6.63201 4.75736 7.75723C3.63214 8.88245 3 10.4086 3 11.9999V13.1249C3 13.2243 3.03951 13.3197 3.10984 13.39C3.18016 13.4604 3.27554 13.4999 3.375 13.4999H44.625C44.7245 13.4999 44.8198 13.4604 44.8902 13.39C44.9605 13.3197 45 13.2243 45 13.1249V11.9999Z"
          fill="#7B6CCC"
        />
        <path
          d="M3 39C3 40.5913 3.63214 42.1174 4.75736 43.2426C5.88258 44.3679 7.4087 45 9 45H39C40.5913 45 42.1174 44.3679 43.2426 43.2426C44.3679 42.1174 45 40.5913 45 39V16.7812C45 16.7067 44.9704 16.6351 44.9176 16.5824C44.8649 16.5296 44.7933 16.5 44.7188 16.5H3.28125C3.20666 16.5 3.13512 16.5296 3.08238 16.5824C3.02963 16.6351 3 16.7067 3 16.7812V39ZM35.25 19.5C35.695 19.5 36.13 19.632 36.5 19.8792C36.87 20.1264 37.1584 20.4778 37.3287 20.889C37.499 21.3001 37.5436 21.7525 37.4568 22.189C37.37 22.6254 37.1557 23.0263 36.841 23.341C36.5263 23.6557 36.1254 23.87 35.689 23.9568C35.2525 24.0436 34.8001 23.999 34.389 23.8287C33.9778 23.6584 33.6264 23.37 33.3792 23C33.132 22.63 33 22.195 33 21.75C33 21.1533 33.2371 20.581 33.659 20.159C34.081 19.7371 34.6533 19.5 35.25 19.5ZM35.25 27C35.695 27 36.13 27.132 36.5 27.3792C36.87 27.6264 37.1584 27.9778 37.3287 28.389C37.499 28.8001 37.5436 29.2525 37.4568 29.689C37.37 30.1254 37.1557 30.5263 36.841 30.841C36.5263 31.1557 36.1254 31.37 35.689 31.4568C35.2525 31.5436 34.8001 31.499 34.389 31.3287C33.9778 31.1584 33.6264 30.87 33.3792 30.5C33.132 30.13 33 29.695 33 29.25C33 28.6533 33.2371 28.081 33.659 27.659C34.081 27.2371 34.6533 27 35.25 27ZM27.75 19.5C28.195 19.5 28.63 19.632 29 19.8792C29.37 20.1264 29.6584 20.4778 29.8287 20.889C29.999 21.3001 30.0436 21.7525 29.9568 22.189C29.87 22.6254 29.6557 23.0263 29.341 23.341C29.0263 23.6557 28.6254 23.87 28.189 23.9568C27.7525 24.0436 27.3001 23.999 26.889 23.8287C26.4778 23.6584 26.1264 23.37 25.8792 23C25.632 22.63 25.5 22.195 25.5 21.75C25.5 21.1533 25.7371 20.581 26.159 20.159C26.581 19.7371 27.1533 19.5 27.75 19.5ZM27.75 27C28.195 27 28.63 27.132 29 27.3792C29.37 27.6264 29.6584 27.9778 29.8287 28.389C29.999 28.8001 30.0436 29.2525 29.9568 29.689C29.87 30.1254 29.6557 30.5263 29.341 30.841C29.0263 31.1557 28.6254 31.37 28.189 31.4568C27.7525 31.5436 27.3001 31.499 26.889 31.3287C26.4778 31.1584 26.1264 30.87 25.8792 30.5C25.632 30.13 25.5 29.695 25.5 29.25C25.5 28.6533 25.7371 28.081 26.159 27.659C26.581 27.2371 27.1533 27 27.75 27ZM27.75 34.5C28.195 34.5 28.63 34.632 29 34.8792C29.37 35.1264 29.6584 35.4778 29.8287 35.889C29.999 36.3001 30.0436 36.7525 29.9568 37.189C29.87 37.6254 29.6557 38.0263 29.341 38.341C29.0263 38.6557 28.6254 38.87 28.189 38.9568C27.7525 39.0436 27.3001 38.999 26.889 38.8287C26.4778 38.6584 26.1264 38.37 25.8792 38C25.632 37.63 25.5 37.195 25.5 36.75C25.5 36.1533 25.7371 35.581 26.159 35.159C26.581 34.7371 27.1533 34.5 27.75 34.5ZM20.25 27C20.695 27 21.13 27.132 21.5 27.3792C21.87 27.6264 22.1584 27.9778 22.3287 28.389C22.499 28.8001 22.5436 29.2525 22.4568 29.689C22.37 30.1254 22.1557 30.5263 21.841 30.841C21.5263 31.1557 21.1254 31.37 20.689 31.4568C20.2525 31.5436 19.8001 31.499 19.389 31.3287C18.9778 31.1584 18.6264 30.87 18.3792 30.5C18.132 30.13 18 29.695 18 29.25C18 28.6533 18.2371 28.081 18.659 27.659C19.081 27.2371 19.6533 27 20.25 27ZM20.25 34.5C20.695 34.5 21.13 34.632 21.5 34.8792C21.87 35.1264 22.1584 35.4778 22.3287 35.889C22.499 36.3001 22.5436 36.7525 22.4568 37.189C22.37 37.6254 22.1557 38.0263 21.841 38.341C21.5263 38.6557 21.1254 38.87 20.689 38.9568C20.2525 39.0436 19.8001 38.999 19.389 38.8287C18.9778 38.6584 18.6264 38.37 18.3792 38C18.132 37.63 18 37.195 18 36.75C18 36.1533 18.2371 35.581 18.659 35.159C19.081 34.7371 19.6533 34.5 20.25 34.5ZM12.75 27C13.195 27 13.63 27.132 14 27.3792C14.37 27.6264 14.6584 27.9778 14.8287 28.389C14.999 28.8001 15.0436 29.2525 14.9568 29.689C14.87 30.1254 14.6557 30.5263 14.341 30.841C14.0263 31.1557 13.6254 31.37 13.189 31.4568C12.7525 31.5436 12.3001 31.499 11.889 31.3287C11.4778 31.1584 11.1264 30.87 10.8792 30.5C10.632 30.13 10.5 29.695 10.5 29.25C10.5 28.6533 10.7371 28.081 11.159 27.659C11.581 27.2371 12.1533 27 12.75 27ZM12.75 34.5C13.195 34.5 13.63 34.632 14 34.8792C14.37 35.1264 14.6584 35.4778 14.8287 35.889C14.999 36.3001 15.0436 36.7525 14.9568 37.189C14.87 37.6254 14.6557 38.0263 14.341 38.341C14.0263 38.6557 13.6254 38.87 13.189 38.9568C12.7525 39.0436 12.3001 38.999 11.889 38.8287C11.4778 38.6584 11.1264 38.37 10.8792 38C10.632 37.63 10.5 37.195 10.5 36.75C10.5 36.1533 10.7371 35.581 11.159 35.159C11.581 34.7371 12.1533 34.5 12.75 34.5Z"
          fill="#7B6CCC"
        />
      </svg>
    </div>
    <div
      variant="page-title"
      style="margin-bottom: 77px; max-width: 600px; text-align: center"
    >
      Még nem érkezett foglalás az eseményeidre.
    </div>
    <div class="info-card">
      <div variant="table-head-button-label" style="margin-bottom: 16px">
        Néhány tipp:
      </div>
      <div v-for="tip in tips" :key="tip.id" variant="list-item">
        <span>{{ tip.id }}. </span>{{ tip.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const tips = [
      {
        id: 1,
        text: "Ha nem hoztál még létre eseményt, akkor mindenféleképpen tedd meg. Csak meghirdetett eseményekhez érkezhetnek foglalások a Bortúra Appon keresztül.",
      },
      {
        id: 2,
        text: "Ha már meghirdettél eseményt, de még nem érkezett foglalás, akkor javasoljuk, hogy promózd be a közösségi oldalaidon is.",
      },
      {
        id: 3,
        text: "Ha posztolsz róla, akkor mindenképpen jelezd a vendégeidnek, hogy a Bortúra Appon gyorsan és egyszerűen le tudják foglalni helyüket az eseményre.",
      },
    ];

    return {
      tips,
    };
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.info-card {
  padding: 48px;
  background-color: var(--color-red-07);
  max-width: 900px;
  border-radius: 8px;
}
.icon {
  color: var(--color-blue-04);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: var(--color-red-07);
  border-radius: 60px;
  margin-bottom: 16px;
  font-size: 48px;
}
</style>